module.exports = __webpack_public_path__ + "static/media/AWS_GPU_Metrics_Collection_Serra_Labs.6c8f2b35.pdf";